import queryString from "query-string";
import { defaultQuickViewQueries } from "constants/reports";

import { QuickViewQueries, UrlQueryParams } from "store/types";

export const quickViewQueriesFromURL = (search: string): QuickViewQueries => {
  const filteredEmail = search.replace(/(email.+)\+/g, "%2B");
  const { quickViewQueries }: UrlQueryParams = queryString.parseUrl(filteredEmail).query;

  const queries = quickViewQueries ? (JSON.parse(quickViewQueries) as Partial<QuickViewQueries>) : {};
  return {
    ...defaultQuickViewQueries,
    ...queries,
    // Deep merge columns so new fields (visibleSystemColumns, columnsOrder) always have defaults
    // even when loading from an older URL that didn't include them
    columns: {
      ...defaultQuickViewQueries.columns,
      ...queries.columns
    }
  };
};
